import { render } from "./App.vue?vue&type=template&id=3074650e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3074650e&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/krivtsovip.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__